module.exports = __webpack_public_path__ + "static/the-cactus-44e5814b23402a9e7fd9ef463edd90f3.jpg";